import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ReactGA from 'react-ga';

import 'bootstrap-material-design/dist/js/ripples.js';
import 'bootstrap-material-design/dist/js/material.js';

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
